
import Vue from "vue"
import Preview from '@/components/preview/index.vue'
import Menu from '@/components/Aside/menu/index.vue'
export default Vue.extend({
 components:{
	Preview,
	Menu
 }
})
